import React from "react";
import { usePanelData } from "../usePanelData";
import type { DataBinding, ResolvedRange } from "../spec";

interface StatPanelProps {
  title?: string;
  binding: DataBinding;
  range: ResolvedRange;
}

/** Compact single-value tile(s) — the latest value of each channel. */
const StatPanel: React.FC<StatPanelProps> = ({ title, binding, range }) => {
  const { latest } = usePanelData(binding, range);

  return (
    <div className="w-full h-full flex flex-col justify-center gap-2 p-3">
      {title && (
        <div className="text-xs font-medium text-gray-500 dark:text-gray-400">
          {title}
        </div>
      )}
      {binding.channels.map((ch) => {
        const value = latest.get(ch.key);
        return (
          <div key={ch.key} className="flex items-baseline justify-between">
            <span className="text-xs text-gray-500 dark:text-gray-400">
              {ch.label ?? ch.key}
            </span>
            <span className="text-lg font-bold text-gray-900 dark:text-white">
              {value !== undefined ? value.toFixed(2) : "—"}
              {ch.unit ? (
                <span className="text-xs font-normal text-gray-500 ml-1">
                  {ch.unit}
                </span>
              ) : null}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default StatPanel;
